module.exports = __webpack_public_path__ + "static/Paroles-de-Fromagers.56630c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Paroles-de-Fromagers.jpg
// module id = 464
// module chunks = 35783957827783